import React, { useContext, useState, useEffect } from 'react';
import 'antd/dist/antd.css';
import { Button, Input, Switch } from 'antd'
import { UpOutlined, DownOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons'

import GeneralContext from '../../context/GeneralContext/GeneralContext';

import api from '../../services/api';
import SL_Date from '../../components/dates/Date';
import { DateTime } from 'luxon';
import SL_Button from '../../components/buttons/Button';
import moment from 'moment';
import { SL_AutoCompleteSelect } from '../../components/selects/SL_AutoCompleteSelect';
import { displayMessage } from '../../services/helper';

export default function ControlFilters(props) {

    const [currentFilters, setCurrentFilters] = useState({})
    const [isTotalizerVisable, setIsTotalizerVisable] = useState(false)

    const { lastMoonday, nextFriday, handleOnlyFromGhostMonitor } = props

    const currentUserType = JSON.parse(localStorage.getItem('user'))?.user_type

    const { mobile_mode, enums } = useContext(GeneralContext)

    useEffect(() => {
        setCurrentFilters({ ...currentFilters, start_date: moment(lastMoonday).format('YYYY-MM-DD'), end_date: moment(nextFriday).format('YYYY-MM-DD') })
    }, [])

    let populateDentistsTimeout;
    async function populateDentistsSelect(value) {
        return new Promise((resolve) => {
            clearTimeout(populateDentistsTimeout);
            populateDentistsTimeout = setTimeout(async () => {
                const options = [];
                const filterValue = value.toUpperCase();
                const { data } = await api.dentist.list({find: value, limit_to_x_registers: 50});
                data.map((dentist) => {
                    const dentistFullName = dentist.full_name.toUpperCase();
                    if (dentistFullName.includes(filterValue)) {
                        const alreadyUsed = options.find(e => e.value == dentist.full_name);
                        if (!alreadyUsed) {
                            let option = {
                                key: dentist.id,
                                label: dentist.full_name,
                                value: dentist.full_name
                            }
                            options.push(option);
                        }
                    }
                })
                resolve(options)
            }, 1000)
        })
    }

    return (
        <div
            style={
                {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    padding: 0,
                    marginBottom: 15,
                    color: 'white',
                    overflow: 'hidden',
                    border: '1px solid lightgrey',
                }
            }
        >
            <div className='flex flex-1 justify-between p-2 bg-appian-blue gap-1 flex-row'>
                <span className='self-center font-medium text-white flex-1 text-center'>{displayMessage('APPOINTMENT_FILTERS')}</span>
                <SL_Button
                    style={{ background: 'white', borderColor: 'darkblue', color: 'black', fontWeight: 'bold' }}
                    className='items-center w-30 flex'
                    onClick={() => { isTotalizerVisable ? setIsTotalizerVisable(false) : setIsTotalizerVisable(true) }}
                    shape="circle"
                    icon={isTotalizerVisable ? <DownOutlined /> : <UpOutlined />}
                />
            </div>
            {isTotalizerVisable &&

                <div style={{ display: 'flex', flexDirection: 'column', flex: 1, background: '#efefef' }}>

                    <div style={{ display: 'flex', flexDirection: mobile_mode ? `column` : `row`, flex: 1, flexWrap: 'wrap', padding: 5, alignItems: 'center' }}>

                        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', flex: 1 }}>
                            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', flex: 1, maxWidth: (currentUserType == enums?.EUserTypes?.DENTIST?.code) ? 260 : 510 }}>
                                {
                                     currentUserType == enums?.EUserTypes?.DENTIST?.code ?
                                     <></>
                                     :
                                     <div style={{ display: 'flex', flexDirection: mobile_mode ? 'row' : 'column', marginRight: 5 }}>
                                         <div style={{ fontWeight: 'bold', color: '#1b3663', marginRight: mobile_mode ? 10 : 0}}> {displayMessage('DENTIST')}:</div>
                                         <SL_AutoCompleteSelect
                                             onChange={e => setCurrentFilters({ ...currentFilters, dentist_id: e.map(f => f.key) })}
                                             placeholder={displayMessage('DENTIST')}
                                             fetchOptions={e => populateDentistsSelect(e)}
                                             style={{ width: 250, maxHeight: 85, overflowY: "auto" }}
                                             allowClear
                                         />
                                     </div>
                                }

                                <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5 }}>
                                    <div style={{ fontWeight: 'bold', color: '#1b3663' }}> {displayMessage('PATIENT')}:</div>
                                    <Input
                                        style={{ width: 250 }}
                                        type="text"
                                        placeholder={displayMessage('SEARCH_PATIENT')}
                                        onChange={e => setCurrentFilters({ ...currentFilters, find: e.target.value })}
                                    />
                                </div>

                            </div>

                            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', flex: 1, maxWidth: 450}}>
                                <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5 }}>
                                    <div style={{ fontWeight: 'bold', color: '#1b3663' }}> {displayMessage('INITIAL_DATE')}:</div>
                                    <SL_Date
                                        placeholder={displayMessage('SELECT_DATE')}
                                        defaultValue={moment(lastMoonday)}
                                        style={{ width: 200, }}
                                        format={'DD/MM/YYYY'}
                                        onChange={start_date => setCurrentFilters({ ...currentFilters, start_date: start_date?.format('YYYY-MM-DD') })}
                                        disabledDate={
                                            (current) => {
                                                return currentFilters.end_date ? current && current > DateTime.fromISO(currentFilters.end_date) : false

                                            }
                                        }
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5 }}>
                                    <div style={{ fontWeight: 'bold', color: '#1b3663' }}> {displayMessage('FINAL_DATE')}:</div>
                                    <SL_Date
                                        placeholder={displayMessage('SELECT_DATE')}
                                        defaultValue={moment(nextFriday)}
                                        style={{ width: 200, }}
                                        format={'DD/MM/YYYY'}
                                        onChange={
                                            end_date => setCurrentFilters({ ...currentFilters, end_date: end_date?.format('YYYY-MM-DD') })
                                        }
                                        disabledDate={
                                            (current) => {
                                                return currentFilters.start_date ? current && current < DateTime.fromISO(currentFilters.start_date) : false
                                            }
                                        }
                                    />
                                </div>

                            </div>
                        </div>

                        <div style={{display: 'flex', flex: 1, flexDirection: 'column', maxWidth: 210}}>
                            { handleOnlyFromGhostMonitor != null &&
                                <div style={{ display: 'flex', flexDirection: mobile_mode ? 'row' : 'column', marginRight: mobile_mode ? 0 : 10, marginLeft: mobile_mode ? 0 : 10 }}>
                                    <div style={{ fontWeight: 'bold', color: '#1b3663', marginRight: mobile_mode ? 10 : 0 }}> {displayMessage('ONLY_GHOST_MONITORS')}</div>
                                    <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
                                        <Switch
                                            defaultChecked={false}
                                            style={{ display: 'flex', flex: 1, minHeight: 29, maxWidth: 45, alignItems: 'center'}}
                                            onChange={(e) => {
                                                handleOnlyFromGhostMonitor(e)
                                            }}
                                            checkedChildren={<CheckOutlined />}
                                            unCheckedChildren={<CloseOutlined />}
                                        />
                                    </div>
                                </div>
                            }
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: 5, alignItems: 'flex-end', marginTop: 10, padding: 5 }}>
                                <Button
                                    onClick={() => props.handleOnSearchControls(currentFilters)}
                                    type="primary"
                                    style={{ marginRight: 5, width: 200, height: 40, fontWeight: 'bold', borderRadius: 7 }}
                                >
                                    {displayMessage('SEARCH')}
                                </Button>
                            </div>

                        </div>
                    </div>
                </div>
            }
        </div >


    )
}


